import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const setIsCancellingPrescription: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (value: boolean) => void
> = (set) => (value) =>
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionSubmitState.isCancellingPrescription = value;
    },
    false,
    'prescriptionSubmit/setIsCancellingPrescription',
  );
